module.exports = __webpack_public_path__ + "static/media/Cards.be262b22.png";